import { createContext } from 'react'
import { SurveyTranslation } from '@tm/shared-lib/src/i18n'
export const TranslationsContext = createContext<
  { surveyLanguages: SurveyTranslation[]; lang: string; useDefault?: boolean } | undefined
>(undefined)
